export Animation from './Animation'

export default from './Animation'



// WEBPACK FOOTER //
// ./src/Animation/index.js